import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button, CarouselNew, CarouselNewArrow } from 'components'
import { StoreCard } from 'components/store-card'
import { CarouselArrowBanner } from '../carousel-arrow-banner'
import './style.scss'

export function StoreProducts({ categories, handleOpenProductDetail }) {
  const [products, setProducts] = useState([])
  const [banners, setBanners] = useState([])
  const [selectedCategory, setSelectedCategory] = useState(null)
  const { banners: allBanners } = useSelector(state => state.banners)

  useEffect(() => {
    const storeBanners = allBanners.filter(banner => banner.isSoftbundle)
    setBanners(storeBanners)
  }, [allBanners])

  useEffect(() => {
    const firstCategory = categories[0]
    setSelectedCategory(firstCategory?.category)
  }, [categories])

  useEffect(() => {
    if (selectedCategory) {
      const categoryProducts = categories.find(({ category }) => category === selectedCategory)
      setProducts(categoryProducts.products)
    }
  }, [categories, selectedCategory])

  function handleBannerClick({ product }) {
    handleOpenProductDetail(product)
  }

  function handleCategoryClick(category) {
    setSelectedCategory(category)
  }

  function renderBanners() {
    const images = banners.map((banner, index) => (
      <button
        key={index}
        type='button'
        onClick={() => handleBannerClick(banner)}
        className='product-banner-button'
      >
        <img
          className='product-banner'
          key={index}
          src={banner.image}
          alt={banner.product.description}
        />
      </button>
    ))
    return (
      <div className='banner-carousel'>
        <CarouselNew loop customArrowComponent={CarouselArrowBanner} autoPlaySpeed={5000}>
          {images}
        </CarouselNew>
      </div>
    )
  }

  function renderCategory({ category }) {
    const isSelected = selectedCategory === category

    return (
      <div key={category} className='store-category-button-container'>
        <Button
          type='button'
          className={`store-category-button ${isSelected && '-active'}`}
          key={category}
          onClick={() => handleCategoryClick(category)}
        >
          {category}
        </Button>
      </div>
    )
  }

  function renderCategoryArrow(props) {
    return <CarouselNewArrow className='categories-carousel-arrow' {...props} />
  }

  function renderCategories() {
    return (
      <div className='categories-carousel'>
        <CarouselNew variableWidth customArrowComponent={renderCategoryArrow}>
          {categories.map(renderCategory)}
        </CarouselNew>
      </div>
    )
  }

  function renderProducts() {
    return products.map(product => (
      <StoreCard key={product.familyName} product={product} onAddItem={handleOpenProductDetail} />
    ))
  }

  return (
    <div className='container-store'>
      <div className='container-banners'>{renderBanners()}</div>
      <div className='container-categories'>{renderCategories()}</div>
      <div className='container-cards'>{renderProducts()}</div>
    </div>
  )
}
